// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import ProgramFavourite from './ProgramFavourite'
import ProgramsFilters from './ProgramsFilters'

// Redux:
import { getAccountLikesData, cleanupRemovedLikes, setHasScrolledToProgramsPage } from 'actions/site'

class Favourites extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch( getAccountLikesData() )
	}

	componentWillUnmount() {
		const { dispatch } = this.props

		dispatch( cleanupRemovedLikes() )
	}

	componentDidUpdate() {
		const { dispatch, hasScrolledToProgramsPage, programsPageScrollOffset } = this.props

		if ( ! hasScrolledToProgramsPage && this.refPrograms ) {
			zenscroll.setup( null, programsPageScrollOffset )
			zenscroll.to( this.refPrograms )

			dispatch( setHasScrolledToProgramsPage() )
		}
	}

	render() {
		const { loggedIn, categoriesById, programsById, filteredProgramIds, accountData, hasReceivedLikesData } = this.props

		if ( ! loggedIn ) {
			return null
		}

		let markup = []
		let likedPrograms = []
		let likesKeys = []
		let likesMissing = {}

		if ( accountData && accountData.likes_series && Object.keys( accountData.likes_series ).length ) {
			likedPrograms = Object.keys( accountData.likes_series ).map( key => key )
			likesKeys = Object.keys( accountData.likes )
			likesMissing = {
				...accountData.likes
			}
		}

		if ( programsById && Object.keys( programsById ).length ) {
			markup = Object.keys( programsById )
				.map( key => {
					// Check search term - if matches, show all tracks:
					let skipSearchCheck = false

					if ( filteredProgramIds.indexOf( key ) !== -1 ) {
						skipSearchCheck = true
					}

					let item = programsById[ key ]

					if ( likedPrograms.indexOf( item.slug ) === -1 ) {
						return
					}

					// Remove these from the missing list:
					likesKeys.forEach( key => {
						if ( likesMissing[ key ] && likesMissing[ key ].series_slug == item.slug ) {
							delete likesMissing[ key ]
						}
					} )

					return (
						<ProgramFavourite
							key={ item.slug }
							data={ item }
							skipSearchCheck={ skipSearchCheck }
						/>
					)
				} )
		}

		if ( likesMissing && Object.keys( likesMissing ).length ) {
			markup.push(
				<ProgramFavourite
					key="other"
					data={ {
						slug: 'other',
						title: 'Other Programs',
						excerpt: '',
						content: '',
						podcasts_enabled: '',
						featured_image_index: {
							alt: '',
							url: `${siteData.images_url}programs/program-default-thumbnail-r4.png`,
							srcset: ''
						}
					} }
					likesOverride={ likesMissing }
				/>
			)
		}

		markup = markup.filter( Boolean )

		return (
			<div className="programs-wide-section">
				<ProgramsFilters />

				<div className="-tabs" ref={ ( e ) => { this.refPrograms = e } }>
					<NavLink to="/programs/" activeClassName="is-active">Programs</NavLink>
					<NavLink to="/podcasts/" activeClassName="is-active">Podcasts</NavLink>
					<NavLink to="/favourites/" activeClassName="is-active">Favourites</NavLink>
					<NavLink to="/schedule/" activeClassName="is-active">Schedule</NavLink>
				</div>

				<div className="programs">
					<div className="-inner">
						{ markup }

						{ ( hasReceivedLikesData && ! markup.length ) &&
							<div className="favourites-empty">
								<h2>You haven't added any favourites yet</h2>

								<p>Add favourites while you're listening using the <i className="icon icon-heart-o"></i></p>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		programsById: state.programs.byId,
		filteredProgramIds: state.programs.filteredProgramIds,
		categoriesById: state.programs.categoriesById,
		accountData: state.site.accountData,
		loggedIn: state.site.loggedIn,
		hasScrolledToProgramsPage: state.site.hasScrolledToProgramsPage,
		programsPageScrollOffset: state.site.programsPageScrollOffset,
		hasReceivedLikesData: state.site.hasReceivedLikesData
	}
}

export default connect( mapStateToProps )( Favourites )
